export const isShareApp = (): boolean => {
  return window.location.hostname.includes('share.');
};

export const isAdminApp = (): boolean => {
  return window.location.hostname.includes('admin.');
};
